import { Model } from '@mode-vegas/vegas';

import { FlamingoTypes } from '@mode/shared/contract-common';

import {
  Dataset,
  QueryResource,
  QueryResultResource,
  QueryRunResource,
  ReportRunResource,
} from '@mode/legacy/data-access-model-js';
import { ReportDomain } from '@mode/shared/contract-common';
import { ReportRunActionType } from '@mode/legacy/util-domain';

export { ReportRunActionType };

export interface PollReportRunAction {
  type: ReportRunActionType.PollReportRun;
  token: string;
}

export interface PollReportRunFailedAction {
  type: ReportRunActionType.PollReportRunFailed;
  token: string;
  error: Error;
}

export interface ExecuteReportRunAction {
  type: ReportRunActionType.ExecuteReportRun;
  selectedText?: string;
  runningQueryToken?: string;
  runningQueryLimit?: boolean;
}

export interface ExecuteReportRunSuccessAction {
  type: ReportRunActionType.ExecuteReportRunSuccess;
  reportRunResource: ReportRunResource;
  runningQueryToken?: string;
  isNew: boolean; // marks whether the report is new at the time of the run
}

export interface ExecuteReportRunFailedAction {
  type: ReportRunActionType.ExecuteReportRunFailed;
  runningQueryToken?: string;
  error: Error;
  errorCause: ReportDomain.ReportRunFailCause;
}

export interface ExecutePreviewTableQueryRunAction {
  type: ReportRunActionType.ExecutePreviewTableQueryRun;
  runningQueryToken: string;
  selectedText: string;
  tableSchema: string;
  tableName: string;
  buttonLocation: string;
  searchQuery: string;
  runningQueryLimit: boolean; // this is the only reason this action exists, see ReportRunDataService
}

export interface CancelPollReportRunAction {
  type: ReportRunActionType.CancelPollReportRun;
}

export interface CancelQueryRunAction {
  type: ReportRunActionType.CancelQueryRun;
  token: string;
}

export interface PollReportRunCompleteAction {
  type: ReportRunActionType.PollReportRunComplete;
  token: string;
}

export interface ReportRunLoadSuccessAction {
  type: ReportRunActionType.ReportRunLoadSuccess;
  resource: ReportRunResource;
}

export interface ReportRunLoadFailureAction {
  type: ReportRunActionType.ReportRunLoadFailure;
  token: string;
  error: Error;
}

export interface RefreshReportRunAfterCellExport {
  type: ReportRunActionType.RefreshReportRunAfterCellExport;
  reportRunResource: ReportRunResource;
  notebookToken: string;
  exportedDatasetToken: string;
}

export interface LoadQueryRunSuccess {
  type: ReportRunActionType.LoadQueryRunSuccess;
  resource: QueryRunResource;
  mapping_id?: string; // if it was a new query, the old placeholder token
}

export class LoadQueryRunView {
  public readonly type = ReportRunActionType.LoadQueryRunView;
  constructor(
    public readonly resource: QueryRunResource,
    public readonly resultResource: QueryResultResource,
    public readonly view: FlamingoTypes.ModeView
  ) {}
}

export interface LoadQueryResultSuccess {
  type: ReportRunActionType.LoadQueryResultSuccess;
  queryRun: QueryRunResource;
  queryResource: QueryResource;
  resource: QueryResultResource;
  dataset?: Dataset;
  model?: Model;
  view?: FlamingoTypes.ModeView;
}

export interface LoadQueryResultFailure {
  type: ReportRunActionType.LoadQueryResultFailure;
  queryRun: QueryRunResource;
  queryResource: QueryResource;
}

export interface ReportRoutesNoScriptOrLegacy {
  type: ReportRunActionType.ReportRoutesNoScriptOrLegacy;
  queryRun: QueryRunResource;
  queryResource: QueryResource;
}

export interface LoadCsvSuccess {
  type: ReportRunActionType.LoadCsvSuccess;
  queryRun: QueryRunResource;
  queryResult: QueryResultResource;
  csv: any;
}

export type ReportRunActions =
  | PollReportRunAction
  | PollReportRunFailedAction
  | ExecuteReportRunAction
  | ExecuteReportRunSuccessAction
  | ExecuteReportRunFailedAction
  | ExecutePreviewTableQueryRunAction
  | CancelPollReportRunAction
  | CancelQueryRunAction
  | PollReportRunCompleteAction
  | ReportRunLoadSuccessAction
  | ReportRunLoadFailureAction
  | LoadQueryRunSuccess
  | LoadQueryResultSuccess
  | LoadQueryResultFailure
  | LoadCsvSuccess
  | LoadQueryRunView
  | ReportRoutesNoScriptOrLegacy
  | RefreshReportRunAfterCellExport;
